module.exports = __webpack_public_path__ + "img/icon_permission_over.1696b512.svg";